import "./main.css";
import $b4euU$spectrumiconsuiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import {Button as $b4euU$Button, ActionButton as $b4euU$ActionButton} from "@react-spectrum/button";
import {ButtonGroup as $b4euU$ButtonGroup} from "@react-spectrum/buttongroup";
import {chain as $b4euU$chain, mergeProps as $b4euU$mergeProps} from "@react-aria/utils";
import {useStyleProps as $b4euU$useStyleProps, classNames as $b4euU$classNames, useSlotProps as $b4euU$useSlotProps, useDOMRef as $b4euU$useDOMRef, useHasChild as $b4euU$useHasChild, unwrapDOMRef as $b4euU$unwrapDOMRef, SlotProvider as $b4euU$SlotProvider, useIsMobileDevice as $b4euU$useIsMobileDevice} from "@react-spectrum/utils";
import {Content as $b4euU$Content} from "@react-spectrum/view";
import {Divider as $b4euU$Divider} from "@react-spectrum/divider";
import {Heading as $b4euU$Heading} from "@react-spectrum/text";
import $b4euU$react, {useContext as $b4euU$useContext, forwardRef as $b4euU$forwardRef, useRef as $b4euU$useRef, useMemo as $b4euU$useMemo, useEffect as $b4euU$useEffect, Fragment as $b4euU$Fragment, useState as $b4euU$useState} from "react";
import {useLocalizedStringFormatter as $b4euU$useLocalizedStringFormatter} from "@react-aria/i18n";
import $b4euU$spectrumiconsuiCrossLarge from "@spectrum-icons/ui/CrossLarge";
import {Grid as $b4euU$Grid} from "@react-spectrum/layout";
import {useDialog as $b4euU$useDialog} from "@react-aria/dialog";
import {Modal as $b4euU$Modal, Tray as $b4euU$Tray, Popover as $b4euU$Popover} from "@react-spectrum/overlays";
import {useOverlayTriggerState as $b4euU$useOverlayTriggerState} from "@react-stately/overlays";
import {PressResponder as $b4euU$PressResponder} from "@react-aria/interactions";
import {useOverlayTrigger as $b4euU$useOverlayTrigger} from "@react-aria/overlays";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $97b119e05830ea0d$export$8b93a07348a7730c = (0, $b4euU$react).createContext(null);



var $f3fff851f5cc5a1e$exports = {};
var $cc8cbf248c4ac933$exports = {};
$cc8cbf248c4ac933$exports = {
    "alert": `\u{62A}\u{646}\u{628}\u{64A}\u{647}`,
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};


var $c23042f930ed2466$exports = {};
$c23042f930ed2466$exports = {
    "alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B}`,
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};


var $22339168a6e88f2f$exports = {};
$22339168a6e88f2f$exports = {
    "alert": `V\xfdstraha`,
    "dismiss": `Odstranit`
};


var $ec8dd13b968e5322$exports = {};
$ec8dd13b968e5322$exports = {
    "alert": `Advarsel`,
    "dismiss": `Luk`
};


var $39167ee9a84b7061$exports = {};
$39167ee9a84b7061$exports = {
    "alert": `Warnhinweis`,
    "dismiss": `Schlie\xdfen`
};


var $1704ee735c76afc9$exports = {};
$1704ee735c76afc9$exports = {
    "alert": `\u{395}\u{3B9}\u{3B4}\u{3BF}\u{3C0}\u{3BF}\u{3AF}\u{3B7}\u{3C3}\u{3B7}`,
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};


var $0cb312c2797e7a68$exports = {};
$0cb312c2797e7a68$exports = {
    "dismiss": `Dismiss`,
    "alert": `Alert`
};


var $95df037910b72a83$exports = {};
$95df037910b72a83$exports = {
    "alert": `Alerta`,
    "dismiss": `Descartar`
};


var $9e83f2ab3a156c72$exports = {};
$9e83f2ab3a156c72$exports = {
    "alert": `Teade`,
    "dismiss": `L\xf5peta`
};


var $f0c4e76101f61910$exports = {};
$f0c4e76101f61910$exports = {
    "alert": `H\xe4lytys`,
    "dismiss": `Hylk\xe4\xe4`
};


var $0e0388177f2c7eb2$exports = {};
$0e0388177f2c7eb2$exports = {
    "alert": `Alerte`,
    "dismiss": `Rejeter`
};


var $fd928d81cf33984c$exports = {};
$fd928d81cf33984c$exports = {
    "alert": `\u{5D4}\u{5EA}\u{5E8}\u{5D0}\u{5D4}`,
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};


var $17a3672f010e4055$exports = {};
$17a3672f010e4055$exports = {
    "alert": `Upozorenje`,
    "dismiss": `Odbaci`
};


var $43993547bd42ef6e$exports = {};
$43993547bd42ef6e$exports = {
    "alert": `Figyelmeztet\xe9s`,
    "dismiss": `Elutas\xedt\xe1s`
};


var $fca04de68cb5ade1$exports = {};
$fca04de68cb5ade1$exports = {
    "alert": `Avviso`,
    "dismiss": `Ignora`
};


var $0d47eca4edb370b0$exports = {};
$0d47eca4edb370b0$exports = {
    "alert": `\u{30A2}\u{30E9}\u{30FC}\u{30C8}`,
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};


var $d791c4a431b7a587$exports = {};
$d791c4a431b7a587$exports = {
    "alert": `\u{ACBD}\u{ACE0}`,
    "dismiss": `\u{BB34}\u{C2DC}`
};


var $35175b1ad320fcc1$exports = {};
$35175b1ad320fcc1$exports = {
    "alert": `\u{12E}sp\u{117}jimas`,
    "dismiss": `Atmesti`
};


var $b9d08f9d50543ce2$exports = {};
$b9d08f9d50543ce2$exports = {
    "alert": `Br\u{12B}din\u{101}jums`,
    "dismiss": `Ner\u{101}d\u{12B}t`
};


var $20889bf3c0d36a01$exports = {};
$20889bf3c0d36a01$exports = {
    "alert": `Varsel`,
    "dismiss": `Lukk`
};


var $f694e1ecd0344008$exports = {};
$f694e1ecd0344008$exports = {
    "alert": `Melding`,
    "dismiss": `Negeren`
};


var $1b424c160db5642d$exports = {};
$1b424c160db5642d$exports = {
    "alert": `Ostrze\u{17C}enie`,
    "dismiss": `Zignoruj`
};


var $5d029553257fceab$exports = {};
$5d029553257fceab$exports = {
    "alert": `Alerta`,
    "dismiss": `Descartar`
};


var $2bea12bc13111737$exports = {};
$2bea12bc13111737$exports = {
    "alert": `Alerta`,
    "dismiss": `Dispensar`
};


var $12084690a0b76ac4$exports = {};
$12084690a0b76ac4$exports = {
    "alert": `Alert\u{103}`,
    "dismiss": `Revocare`
};


var $697f8e526692bd95$exports = {};
$697f8e526692bd95$exports = {
    "alert": `\u{41F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435}`,
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};


var $0802ec67729008c5$exports = {};
$0802ec67729008c5$exports = {
    "alert": `Upozornenie`,
    "dismiss": `Zru\u{161}i\u{165}`
};


var $ef29867297882921$exports = {};
$ef29867297882921$exports = {
    "alert": `Opozorilo`,
    "dismiss": `Opusti`
};


var $39eb6836bb014970$exports = {};
$39eb6836bb014970$exports = {
    "alert": `Upozorenje`,
    "dismiss": `Odbaci`
};


var $b4fa8198ca731e89$exports = {};
$b4fa8198ca731e89$exports = {
    "alert": `Varning`,
    "dismiss": `Avvisa`
};


var $862832bdcbb90256$exports = {};
$862832bdcbb90256$exports = {
    "alert": `Uyar\u{131}`,
    "dismiss": `Kapat`
};


var $2fa80cee796b989c$exports = {};
$2fa80cee796b989c$exports = {
    "alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B} \u{442}\u{440}\u{438}\u{432}\u{43E}\u{433}\u{438}`,
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};


var $ecd80835333d83cc$exports = {};
$ecd80835333d83cc$exports = {
    "alert": `\u{8B66}\u{62A5}`,
    "dismiss": `\u{53D6}\u{6D88}`
};


var $03712eabbcfd201c$exports = {};
$03712eabbcfd201c$exports = {
    "alert": `\u{8B66}\u{793A}`,
    "dismiss": `\u{95DC}\u{9589}`
};


$f3fff851f5cc5a1e$exports = {
    "ar-AE": $cc8cbf248c4ac933$exports,
    "bg-BG": $c23042f930ed2466$exports,
    "cs-CZ": $22339168a6e88f2f$exports,
    "da-DK": $ec8dd13b968e5322$exports,
    "de-DE": $39167ee9a84b7061$exports,
    "el-GR": $1704ee735c76afc9$exports,
    "en-US": $0cb312c2797e7a68$exports,
    "es-ES": $95df037910b72a83$exports,
    "et-EE": $9e83f2ab3a156c72$exports,
    "fi-FI": $f0c4e76101f61910$exports,
    "fr-FR": $0e0388177f2c7eb2$exports,
    "he-IL": $fd928d81cf33984c$exports,
    "hr-HR": $17a3672f010e4055$exports,
    "hu-HU": $43993547bd42ef6e$exports,
    "it-IT": $fca04de68cb5ade1$exports,
    "ja-JP": $0d47eca4edb370b0$exports,
    "ko-KR": $d791c4a431b7a587$exports,
    "lt-LT": $35175b1ad320fcc1$exports,
    "lv-LV": $b9d08f9d50543ce2$exports,
    "nb-NO": $20889bf3c0d36a01$exports,
    "nl-NL": $f694e1ecd0344008$exports,
    "pl-PL": $1b424c160db5642d$exports,
    "pt-BR": $5d029553257fceab$exports,
    "pt-PT": $2bea12bc13111737$exports,
    "ro-RO": $12084690a0b76ac4$exports,
    "ru-RU": $697f8e526692bd95$exports,
    "sk-SK": $0802ec67729008c5$exports,
    "sl-SI": $ef29867297882921$exports,
    "sr-SP": $39eb6836bb014970$exports,
    "sv-SE": $b4fa8198ca731e89$exports,
    "tr-TR": $862832bdcbb90256$exports,
    "uk-UA": $2fa80cee796b989c$exports,
    "zh-CN": $ecd80835333d83cc$exports,
    "zh-TW": $03712eabbcfd201c$exports
};




var $78859b019f1ff3c5$exports = {};

$parcel$export($78859b019f1ff3c5$exports, "buttonGroup", () => $78859b019f1ff3c5$export$9c686a975407e95c, (v) => $78859b019f1ff3c5$export$9c686a975407e95c = v);
$parcel$export($78859b019f1ff3c5$exports, "buttonGroup-end", () => $78859b019f1ff3c5$export$92daf1b0113da0, (v) => $78859b019f1ff3c5$export$92daf1b0113da0 = v);
$parcel$export($78859b019f1ff3c5$exports, "closeButton", () => $78859b019f1ff3c5$export$efe229eab43a9869, (v) => $78859b019f1ff3c5$export$efe229eab43a9869 = v);
$parcel$export($78859b019f1ff3c5$exports, "content", () => $78859b019f1ff3c5$export$a7db06668cad9adb, (v) => $78859b019f1ff3c5$export$a7db06668cad9adb = v);
$parcel$export($78859b019f1ff3c5$exports, "divider", () => $78859b019f1ff3c5$export$e8c9778bf415dd08, (v) => $78859b019f1ff3c5$export$e8c9778bf415dd08 = v);
$parcel$export($78859b019f1ff3c5$exports, "focus-ring", () => $78859b019f1ff3c5$export$f39a09f249340e2a, (v) => $78859b019f1ff3c5$export$f39a09f249340e2a = v);
$parcel$export($78859b019f1ff3c5$exports, "footer", () => $78859b019f1ff3c5$export$adb608be33961c98, (v) => $78859b019f1ff3c5$export$adb608be33961c98 = v);
$parcel$export($78859b019f1ff3c5$exports, "footer-start", () => $78859b019f1ff3c5$export$ba5cbcdd7db6a805, (v) => $78859b019f1ff3c5$export$ba5cbcdd7db6a805 = v);
$parcel$export($78859b019f1ff3c5$exports, "header", () => $78859b019f1ff3c5$export$38e42c68cf43b5d4, (v) => $78859b019f1ff3c5$export$38e42c68cf43b5d4 = v);
$parcel$export($78859b019f1ff3c5$exports, "header-end", () => $78859b019f1ff3c5$export$9ff84a8ef5e6eb7e, (v) => $78859b019f1ff3c5$export$9ff84a8ef5e6eb7e = v);
$parcel$export($78859b019f1ff3c5$exports, "header-start", () => $78859b019f1ff3c5$export$6e2679145d8d7578, (v) => $78859b019f1ff3c5$export$6e2679145d8d7578 = v);
$parcel$export($78859b019f1ff3c5$exports, "heading", () => $78859b019f1ff3c5$export$46e4a324ac90507f, (v) => $78859b019f1ff3c5$export$46e4a324ac90507f = v);
$parcel$export($78859b019f1ff3c5$exports, "heading-start", () => $78859b019f1ff3c5$export$9f99175ea85abb45, (v) => $78859b019f1ff3c5$export$9f99175ea85abb45 = v);
$parcel$export($78859b019f1ff3c5$exports, "hero", () => $78859b019f1ff3c5$export$124049a9e3d0d4c3, (v) => $78859b019f1ff3c5$export$124049a9e3d0d4c3 = v);
$parcel$export($78859b019f1ff3c5$exports, "i18nFontFamily", () => $78859b019f1ff3c5$export$8c4ee2c50c22c514, (v) => $78859b019f1ff3c5$export$8c4ee2c50c22c514 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Button", () => $78859b019f1ff3c5$export$1db4cca5b4ade39a, (v) => $78859b019f1ff3c5$export$1db4cca5b4ade39a = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog", () => $78859b019f1ff3c5$export$4681f3bcac39b2b1, (v) => $78859b019f1ff3c5$export$4681f3bcac39b2b1 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--dismissable", () => $78859b019f1ff3c5$export$9461b285d631d575, (v) => $78859b019f1ff3c5$export$9461b285d631d575 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--error", () => $78859b019f1ff3c5$export$6b5beff56972a3b, (v) => $78859b019f1ff3c5$export$6b5beff56972a3b = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--fullscreen", () => $78859b019f1ff3c5$export$118506da5d3ee7c4, (v) => $78859b019f1ff3c5$export$118506da5d3ee7c4 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--fullscreenTakeover", () => $78859b019f1ff3c5$export$5c061b2d3664fda9, (v) => $78859b019f1ff3c5$export$5c061b2d3664fda9 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--large", () => $78859b019f1ff3c5$export$b73c0c2fca84be2b, (v) => $78859b019f1ff3c5$export$b73c0c2fca84be2b = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--medium", () => $78859b019f1ff3c5$export$b9b8ef443d0a67ca, (v) => $78859b019f1ff3c5$export$b9b8ef443d0a67ca = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--noDivider", () => $78859b019f1ff3c5$export$22425527a8943917, (v) => $78859b019f1ff3c5$export$22425527a8943917 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--small", () => $78859b019f1ff3c5$export$5f2d9cc47409bd63, (v) => $78859b019f1ff3c5$export$5f2d9cc47409bd63 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--warning", () => $78859b019f1ff3c5$export$4e66396adf61534f, (v) => $78859b019f1ff3c5$export$4e66396adf61534f = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-buttonGroup", () => $78859b019f1ff3c5$export$570ae852861555b7, (v) => $78859b019f1ff3c5$export$570ae852861555b7 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-buttonGroup--noFooter", () => $78859b019f1ff3c5$export$39dd75369bf2e830, (v) => $78859b019f1ff3c5$export$39dd75369bf2e830 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-closeButton", () => $78859b019f1ff3c5$export$a8494287d763a75d, (v) => $78859b019f1ff3c5$export$a8494287d763a75d = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-content", () => $78859b019f1ff3c5$export$cb8eccd0f3639238, (v) => $78859b019f1ff3c5$export$cb8eccd0f3639238 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-divider", () => $78859b019f1ff3c5$export$dd7633d642d0bc1c, (v) => $78859b019f1ff3c5$export$dd7633d642d0bc1c = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-footer", () => $78859b019f1ff3c5$export$3ecb5025a06fe08f, (v) => $78859b019f1ff3c5$export$3ecb5025a06fe08f = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-grid", () => $78859b019f1ff3c5$export$c03cd5e23af67ff5, (v) => $78859b019f1ff3c5$export$c03cd5e23af67ff5 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-header", () => $78859b019f1ff3c5$export$1e158eaa6363e131, (v) => $78859b019f1ff3c5$export$1e158eaa6363e131 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-header--noTypeIcon", () => $78859b019f1ff3c5$export$141d8fd0950fea8b, (v) => $78859b019f1ff3c5$export$141d8fd0950fea8b = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-heading", () => $78859b019f1ff3c5$export$94335d73b7b209ec, (v) => $78859b019f1ff3c5$export$94335d73b7b209ec = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-heading--noHeader", () => $78859b019f1ff3c5$export$ade8307239736e89, (v) => $78859b019f1ff3c5$export$ade8307239736e89 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-heading--noTypeIcon", () => $78859b019f1ff3c5$export$c53ac004df29b46, (v) => $78859b019f1ff3c5$export$c53ac004df29b46 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-hero", () => $78859b019f1ff3c5$export$d405fb0a0231aa1a, (v) => $78859b019f1ff3c5$export$d405fb0a0231aa1a = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-typeIcon", () => $78859b019f1ff3c5$export$5beee9480fc6ff07, (v) => $78859b019f1ff3c5$export$5beee9480fc6ff07 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-FocusRing-ring", () => $78859b019f1ff3c5$export$4109102f950813a6, (v) => $78859b019f1ff3c5$export$4109102f950813a6 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-FocusRing", () => $78859b019f1ff3c5$export$24c7f46a6e3605dd, (v) => $78859b019f1ff3c5$export$24c7f46a6e3605dd = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-FocusRing--quiet", () => $78859b019f1ff3c5$export$2927016961429360, (v) => $78859b019f1ff3c5$export$2927016961429360 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-overlay", () => $78859b019f1ff3c5$export$39eed38e2296a1d6, (v) => $78859b019f1ff3c5$export$39eed38e2296a1d6 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-overlay--bottom--open", () => $78859b019f1ff3c5$export$a96755f239de61ee, (v) => $78859b019f1ff3c5$export$a96755f239de61ee = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-overlay--left--open", () => $78859b019f1ff3c5$export$a85c0c6b6cf8598c, (v) => $78859b019f1ff3c5$export$a85c0c6b6cf8598c = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-overlay--open", () => $78859b019f1ff3c5$export$a397eb58038aa381, (v) => $78859b019f1ff3c5$export$a397eb58038aa381 = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-overlay--right--open", () => $78859b019f1ff3c5$export$85aaa87e65e040bf, (v) => $78859b019f1ff3c5$export$85aaa87e65e040bf = v);
$parcel$export($78859b019f1ff3c5$exports, "spectrum-overlay--top--open", () => $78859b019f1ff3c5$export$b9768db7ffc1bc2, (v) => $78859b019f1ff3c5$export$b9768db7ffc1bc2 = v);
$parcel$export($78859b019f1ff3c5$exports, "typeIcon", () => $78859b019f1ff3c5$export$7c523679e5521442, (v) => $78859b019f1ff3c5$export$7c523679e5521442 = v);
$parcel$export($78859b019f1ff3c5$exports, "typeIcon-end", () => $78859b019f1ff3c5$export$b050c62b00f90727, (v) => $78859b019f1ff3c5$export$b050c62b00f90727 = v);
var $78859b019f1ff3c5$export$9c686a975407e95c;
var $78859b019f1ff3c5$export$92daf1b0113da0;
var $78859b019f1ff3c5$export$efe229eab43a9869;
var $78859b019f1ff3c5$export$a7db06668cad9adb;
var $78859b019f1ff3c5$export$e8c9778bf415dd08;
var $78859b019f1ff3c5$export$f39a09f249340e2a;
var $78859b019f1ff3c5$export$adb608be33961c98;
var $78859b019f1ff3c5$export$ba5cbcdd7db6a805;
var $78859b019f1ff3c5$export$38e42c68cf43b5d4;
var $78859b019f1ff3c5$export$9ff84a8ef5e6eb7e;
var $78859b019f1ff3c5$export$6e2679145d8d7578;
var $78859b019f1ff3c5$export$46e4a324ac90507f;
var $78859b019f1ff3c5$export$9f99175ea85abb45;
var $78859b019f1ff3c5$export$124049a9e3d0d4c3;
var $78859b019f1ff3c5$export$8c4ee2c50c22c514;
var $78859b019f1ff3c5$export$1db4cca5b4ade39a;
var $78859b019f1ff3c5$export$4681f3bcac39b2b1;
var $78859b019f1ff3c5$export$9461b285d631d575;
var $78859b019f1ff3c5$export$6b5beff56972a3b;
var $78859b019f1ff3c5$export$118506da5d3ee7c4;
var $78859b019f1ff3c5$export$5c061b2d3664fda9;
var $78859b019f1ff3c5$export$b73c0c2fca84be2b;
var $78859b019f1ff3c5$export$b9b8ef443d0a67ca;
var $78859b019f1ff3c5$export$22425527a8943917;
var $78859b019f1ff3c5$export$5f2d9cc47409bd63;
var $78859b019f1ff3c5$export$4e66396adf61534f;
var $78859b019f1ff3c5$export$570ae852861555b7;
var $78859b019f1ff3c5$export$39dd75369bf2e830;
var $78859b019f1ff3c5$export$a8494287d763a75d;
var $78859b019f1ff3c5$export$cb8eccd0f3639238;
var $78859b019f1ff3c5$export$dd7633d642d0bc1c;
var $78859b019f1ff3c5$export$3ecb5025a06fe08f;
var $78859b019f1ff3c5$export$c03cd5e23af67ff5;
var $78859b019f1ff3c5$export$1e158eaa6363e131;
var $78859b019f1ff3c5$export$141d8fd0950fea8b;
var $78859b019f1ff3c5$export$94335d73b7b209ec;
var $78859b019f1ff3c5$export$ade8307239736e89;
var $78859b019f1ff3c5$export$c53ac004df29b46;
var $78859b019f1ff3c5$export$d405fb0a0231aa1a;
var $78859b019f1ff3c5$export$5beee9480fc6ff07;
var $78859b019f1ff3c5$export$4109102f950813a6;
var $78859b019f1ff3c5$export$24c7f46a6e3605dd;
var $78859b019f1ff3c5$export$2927016961429360;
var $78859b019f1ff3c5$export$39eed38e2296a1d6;
var $78859b019f1ff3c5$export$a96755f239de61ee;
var $78859b019f1ff3c5$export$a85c0c6b6cf8598c;
var $78859b019f1ff3c5$export$a397eb58038aa381;
var $78859b019f1ff3c5$export$85aaa87e65e040bf;
var $78859b019f1ff3c5$export$b9768db7ffc1bc2;
var $78859b019f1ff3c5$export$7c523679e5521442;
var $78859b019f1ff3c5$export$b050c62b00f90727;
$78859b019f1ff3c5$export$9c686a975407e95c = `h_OVWW_buttonGroup`;
$78859b019f1ff3c5$export$92daf1b0113da0 = `h_OVWW_buttonGroup-end`;
$78859b019f1ff3c5$export$efe229eab43a9869 = `h_OVWW_closeButton`;
$78859b019f1ff3c5$export$a7db06668cad9adb = `h_OVWW_content`;
$78859b019f1ff3c5$export$e8c9778bf415dd08 = `h_OVWW_divider`;
$78859b019f1ff3c5$export$f39a09f249340e2a = `h_OVWW_focus-ring`;
$78859b019f1ff3c5$export$adb608be33961c98 = `h_OVWW_footer`;
$78859b019f1ff3c5$export$ba5cbcdd7db6a805 = `h_OVWW_footer-start`;
$78859b019f1ff3c5$export$38e42c68cf43b5d4 = `h_OVWW_header`;
$78859b019f1ff3c5$export$9ff84a8ef5e6eb7e = `h_OVWW_header-end`;
$78859b019f1ff3c5$export$6e2679145d8d7578 = `h_OVWW_header-start`;
$78859b019f1ff3c5$export$46e4a324ac90507f = `h_OVWW_heading`;
$78859b019f1ff3c5$export$9f99175ea85abb45 = `h_OVWW_heading-start`;
$78859b019f1ff3c5$export$124049a9e3d0d4c3 = `h_OVWW_hero`;
$78859b019f1ff3c5$export$8c4ee2c50c22c514 = `h_OVWW_i18nFontFamily`;
$78859b019f1ff3c5$export$1db4cca5b4ade39a = `h_OVWW_spectrum-Button`;
$78859b019f1ff3c5$export$4681f3bcac39b2b1 = `h_OVWW_spectrum-Dialog`;
$78859b019f1ff3c5$export$9461b285d631d575 = `h_OVWW_spectrum-Dialog--dismissable`;
$78859b019f1ff3c5$export$6b5beff56972a3b = `h_OVWW_spectrum-Dialog--error`;
$78859b019f1ff3c5$export$118506da5d3ee7c4 = `h_OVWW_spectrum-Dialog--fullscreen`;
$78859b019f1ff3c5$export$5c061b2d3664fda9 = `h_OVWW_spectrum-Dialog--fullscreenTakeover`;
$78859b019f1ff3c5$export$b73c0c2fca84be2b = `h_OVWW_spectrum-Dialog--large`;
$78859b019f1ff3c5$export$b9b8ef443d0a67ca = `h_OVWW_spectrum-Dialog--medium`;
$78859b019f1ff3c5$export$22425527a8943917 = `h_OVWW_spectrum-Dialog--noDivider`;
$78859b019f1ff3c5$export$5f2d9cc47409bd63 = `h_OVWW_spectrum-Dialog--small`;
$78859b019f1ff3c5$export$4e66396adf61534f = `h_OVWW_spectrum-Dialog--warning`;
$78859b019f1ff3c5$export$570ae852861555b7 = `h_OVWW_spectrum-Dialog-buttonGroup`;
$78859b019f1ff3c5$export$39dd75369bf2e830 = `h_OVWW_spectrum-Dialog-buttonGroup--noFooter`;
$78859b019f1ff3c5$export$a8494287d763a75d = `h_OVWW_spectrum-Dialog-closeButton`;
$78859b019f1ff3c5$export$cb8eccd0f3639238 = `h_OVWW_spectrum-Dialog-content`;
$78859b019f1ff3c5$export$dd7633d642d0bc1c = `h_OVWW_spectrum-Dialog-divider`;
$78859b019f1ff3c5$export$3ecb5025a06fe08f = `h_OVWW_spectrum-Dialog-footer`;
$78859b019f1ff3c5$export$c03cd5e23af67ff5 = `h_OVWW_spectrum-Dialog-grid`;
$78859b019f1ff3c5$export$1e158eaa6363e131 = `h_OVWW_spectrum-Dialog-header`;
$78859b019f1ff3c5$export$141d8fd0950fea8b = `h_OVWW_spectrum-Dialog-header--noTypeIcon`;
$78859b019f1ff3c5$export$94335d73b7b209ec = `h_OVWW_spectrum-Dialog-heading`;
$78859b019f1ff3c5$export$ade8307239736e89 = `h_OVWW_spectrum-Dialog-heading--noHeader`;
$78859b019f1ff3c5$export$c53ac004df29b46 = `h_OVWW_spectrum-Dialog-heading--noTypeIcon`;
$78859b019f1ff3c5$export$d405fb0a0231aa1a = `h_OVWW_spectrum-Dialog-hero`;
$78859b019f1ff3c5$export$5beee9480fc6ff07 = `h_OVWW_spectrum-Dialog-typeIcon`;
$78859b019f1ff3c5$export$4109102f950813a6 = `h_OVWW_spectrum-FocusRing-ring`;
$78859b019f1ff3c5$export$24c7f46a6e3605dd = `h_OVWW_spectrum-FocusRing ${$78859b019f1ff3c5$export$4109102f950813a6}`;
$78859b019f1ff3c5$export$2927016961429360 = `h_OVWW_spectrum-FocusRing--quiet`;
$78859b019f1ff3c5$export$39eed38e2296a1d6 = `h_OVWW_spectrum-overlay`;
$78859b019f1ff3c5$export$a96755f239de61ee = `h_OVWW_spectrum-overlay--bottom--open`;
$78859b019f1ff3c5$export$a85c0c6b6cf8598c = `h_OVWW_spectrum-overlay--left--open`;
$78859b019f1ff3c5$export$a397eb58038aa381 = `h_OVWW_spectrum-overlay--open`;
$78859b019f1ff3c5$export$85aaa87e65e040bf = `h_OVWW_spectrum-overlay--right--open`;
$78859b019f1ff3c5$export$b9768db7ffc1bc2 = `h_OVWW_spectrum-overlay--top--open`;
$78859b019f1ff3c5$export$7c523679e5521442 = `h_OVWW_typeIcon`;
$78859b019f1ff3c5$export$b050c62b00f90727 = `h_OVWW_typeIcon-end`;




let $99cd51dc4eb569f7$var$sizeMap = {
    S: "small",
    M: "medium",
    L: "large",
    fullscreen: "fullscreen",
    fullscreenTakeover: "fullscreenTakeover"
};
function $99cd51dc4eb569f7$var$Dialog(props, ref) {
    props = (0, $b4euU$useSlotProps)(props, "dialog");
    let { type: type = "modal", ...contextProps } = (0, $b4euU$useContext)((0, $97b119e05830ea0d$export$8b93a07348a7730c)) || {};
    let { children: children, isDismissable: isDismissable = contextProps.isDismissable, onDismiss: onDismiss = contextProps.onClose, size: size, ...otherProps } = props;
    let stringFormatter = (0, $b4euU$useLocalizedStringFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($f3fff851f5cc5a1e$exports))), "@react-spectrum/dialog");
    let { styleProps: styleProps } = (0, $b4euU$useStyleProps)(otherProps);
    size = type === "popover" ? size || "S" : size || "L";
    let domRef = (0, $b4euU$useDOMRef)(ref);
    let gridRef = (0, $b4euU$useRef)(null);
    let sizeVariant = $99cd51dc4eb569f7$var$sizeMap[type] || $99cd51dc4eb569f7$var$sizeMap[size];
    let { dialogProps: dialogProps, titleProps: titleProps } = (0, $b4euU$useDialog)((0, $b4euU$mergeProps)(contextProps, props), domRef);
    let hasHeader = (0, $b4euU$useHasChild)(`.${(0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)))["spectrum-Dialog-header"]}`, (0, $b4euU$unwrapDOMRef)(gridRef));
    let hasHeading = (0, $b4euU$useHasChild)(`.${(0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)))["spectrum-Dialog-heading"]}`, (0, $b4euU$unwrapDOMRef)(gridRef));
    let hasFooter = (0, $b4euU$useHasChild)(`.${(0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)))["spectrum-Dialog-footer"]}`, (0, $b4euU$unwrapDOMRef)(gridRef));
    let hasTypeIcon = (0, $b4euU$useHasChild)(`.${(0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)))["spectrum-Dialog-typeIcon"]}`, (0, $b4euU$unwrapDOMRef)(gridRef));
    let slots = (0, $b4euU$useMemo)(()=>({
            hero: {
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)))["spectrum-Dialog-hero"]
            },
            heading: {
                UNSAFE_className: (0, $b4euU$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports))), "spectrum-Dialog-heading", {
                    "spectrum-Dialog-heading--noHeader": !hasHeader,
                    "spectrum-Dialog-heading--noTypeIcon": !hasTypeIcon
                }),
                level: 2,
                ...titleProps
            },
            header: {
                UNSAFE_className: (0, $b4euU$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports))), "spectrum-Dialog-header", {
                    "spectrum-Dialog-header--noHeading": !hasHeading,
                    "spectrum-Dialog-header--noTypeIcon": !hasTypeIcon
                })
            },
            typeIcon: {
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)))["spectrum-Dialog-typeIcon"]
            },
            divider: {
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)))["spectrum-Dialog-divider"],
                size: "M"
            },
            content: {
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)))["spectrum-Dialog-content"]
            },
            footer: {
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)))["spectrum-Dialog-footer"]
            },
            buttonGroup: {
                UNSAFE_className: (0, $b4euU$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports))), "spectrum-Dialog-buttonGroup", {
                    "spectrum-Dialog-buttonGroup--noFooter": !hasFooter
                }),
                align: "end"
            }
        }), [
        hasFooter,
        hasHeader,
        titleProps
    ]);
    return /*#__PURE__*/ (0, $b4euU$react).createElement("section", {
        ...styleProps,
        ...dialogProps,
        className: (0, $b4euU$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports))), "spectrum-Dialog", {
            [`spectrum-Dialog--${sizeVariant}`]: sizeVariant,
            "spectrum-Dialog--dismissable": isDismissable
        }, styleProps.className),
        ref: domRef
    }, /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$Grid), {
        ref: gridRef,
        UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)))["spectrum-Dialog-grid"]
    }, /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$SlotProvider), {
        slots: slots
    }, children), isDismissable && /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$ActionButton), {
        UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)))["spectrum-Dialog-closeButton"],
        isQuiet: true,
        "aria-label": stringFormatter.format("dismiss"),
        onPress: onDismiss
    }, /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$spectrumiconsuiCrossLarge), null))));
}
/**
 * Dialogs are windows containing contextual information, tasks, or workflows that appear over the user interface.
 * Depending on the kind of Dialog, further interactions may be blocked until the Dialog is acknowledged.
 */ let $99cd51dc4eb569f7$export$3ddf2d174ce01153 = /*#__PURE__*/ (0, $b4euU$react).forwardRef($99cd51dc4eb569f7$var$Dialog);









/**
 * AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.
 */ function $2a8395160fff9af3$var$AlertDialog(props, ref) {
    let { onClose: onClose = ()=>{} } = (0, $b4euU$useContext)((0, $97b119e05830ea0d$export$8b93a07348a7730c)) || {};
    let { variant: variant, children: children, primaryActionLabel: primaryActionLabel, secondaryActionLabel: secondaryActionLabel, cancelLabel: cancelLabel, autoFocusButton: autoFocusButton, title: title, isPrimaryActionDisabled: isPrimaryActionDisabled, isSecondaryActionDisabled: isSecondaryActionDisabled, onCancel: onCancel = ()=>{}, onPrimaryAction: onPrimaryAction = ()=>{}, onSecondaryAction: onSecondaryAction = ()=>{}, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $b4euU$useStyleProps)(otherProps);
    let stringFormatter = (0, $b4euU$useLocalizedStringFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($f3fff851f5cc5a1e$exports))), "@react-spectrum/dialog");
    let confirmVariant = "primary";
    if (variant) {
        if (variant === "confirmation") confirmVariant = "cta";
        else if (variant === "destructive") confirmVariant = "negative";
    }
    return /*#__PURE__*/ (0, $b4euU$react).createElement((0, $99cd51dc4eb569f7$export$3ddf2d174ce01153), {
        UNSAFE_style: styleProps.style,
        UNSAFE_className: (0, $b4euU$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports))), {
            [`spectrum-Dialog--${variant}`]: variant
        }, styleProps.className),
        isHidden: styleProps.hidden,
        size: "M",
        role: "alertdialog",
        ref: ref
    }, /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$Heading), null, title), (variant === "error" || variant === "warning") && /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$spectrumiconsuiAlertMedium), {
        slot: "typeIcon",
        "aria-label": stringFormatter.format("alert")
    }), /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$Divider), null), /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$Content), null, children), /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$ButtonGroup), {
        align: "end"
    }, cancelLabel && /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$Button), {
        variant: "secondary",
        onPress: ()=>(0, $b4euU$chain)(onClose(), onCancel()),
        autoFocus: autoFocusButton === "cancel"
    }, cancelLabel), secondaryActionLabel && /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$Button), {
        variant: "secondary",
        onPress: ()=>(0, $b4euU$chain)(onClose(), onSecondaryAction()),
        isDisabled: isSecondaryActionDisabled,
        autoFocus: autoFocusButton === "secondary"
    }, secondaryActionLabel), /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$Button), {
        variant: confirmVariant,
        onPress: ()=>(0, $b4euU$chain)(onClose(), onPrimaryAction()),
        isDisabled: isPrimaryActionDisabled,
        autoFocus: autoFocusButton === "primary"
    }, primaryActionLabel)));
}
/**
 * AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.
 */ let $2a8395160fff9af3$export$de466dd8317b0b75 = /*#__PURE__*/ (0, $b4euU$forwardRef)($2a8395160fff9af3$var$AlertDialog);



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 






function $c412c5ea680c1e4f$var$DialogTrigger(props) {
    let { children: children, type: type = "modal", mobileType: mobileType = type === "popover" ? "modal" : type, hideArrow: hideArrow, targetRef: targetRef, isDismissable: isDismissable, isKeyboardDismissDisabled: isKeyboardDismissDisabled, ...positionProps } = props;
    if (!Array.isArray(children) || children.length > 2) throw new Error("DialogTrigger must have exactly 2 children");
    // if a function is passed as the second child, it won't appear in toArray
    let [trigger, content] = children;
    // On small devices, show a modal or tray instead of a popover.
    let isMobile = (0, $b4euU$useIsMobileDevice)();
    if (isMobile) {
        // handle cases where desktop popovers need a close button for the mobile modal view
        if (type !== "modal" && mobileType === "modal") isDismissable = true;
        type = mobileType;
    }
    let state = (0, $b4euU$useOverlayTriggerState)(props);
    let wasOpen = (0, $b4euU$useRef)(false);
    (0, $b4euU$useEffect)(()=>{
        wasOpen.current = state.isOpen;
    }, [
        state.isOpen
    ]);
    let isExiting = (0, $b4euU$useRef)(false);
    let onExiting = ()=>isExiting.current = true;
    let onExited = ()=>isExiting.current = false;
    // eslint-disable-next-line arrow-body-style
    (0, $b4euU$useEffect)(()=>{
        return ()=>{
            if ((wasOpen.current || isExiting.current) && type !== "popover" && type !== "tray") console.warn("A DialogTrigger unmounted while open. This is likely due to being placed within a trigger that unmounts or inside a conditional. Consider using a DialogContainer instead.");
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (type === "popover") return /*#__PURE__*/ (0, $b4euU$react).createElement($c412c5ea680c1e4f$var$PopoverTrigger, {
        ...positionProps,
        state: state,
        targetRef: targetRef,
        trigger: trigger,
        content: content,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        hideArrow: hideArrow
    });
    let renderOverlay = ()=>{
        switch(type){
            case "fullscreen":
            case "fullscreenTakeover":
            case "modal":
                return /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$Modal), {
                    state: state,
                    isDismissable: type === "modal" ? isDismissable : false,
                    type: type,
                    isKeyboardDismissDisabled: isKeyboardDismissDisabled,
                    onExiting: onExiting,
                    onExited: onExited
                }, typeof content === "function" ? content(state.close) : content);
            case "tray":
                return /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$Tray), {
                    state: state,
                    isKeyboardDismissDisabled: isKeyboardDismissDisabled
                }, typeof content === "function" ? content(state.close) : content);
        }
    };
    return /*#__PURE__*/ (0, $b4euU$react).createElement($c412c5ea680c1e4f$var$DialogTriggerBase, {
        type: type,
        state: state,
        isDismissable: isDismissable,
        trigger: trigger,
        overlay: renderOverlay()
    });
}
// Support DialogTrigger inside components using CollectionBuilder.
$c412c5ea680c1e4f$var$DialogTrigger.getCollectionNode = function*(props) {
    // @ts-ignore - seems like types are wrong. Function children work fine.
    let [trigger] = (0, $b4euU$react).Children.toArray(props.children);
    let [, content] = props.children;
    yield {
        element: trigger,
        wrapper: (element)=>/*#__PURE__*/ (0, $b4euU$react).createElement($c412c5ea680c1e4f$var$DialogTrigger, {
                key: element.key,
                ...props
            }, element, content)
    };
};
/**
 * DialogTrigger serves as a wrapper around a Dialog and its associated trigger, linking the Dialog's
 * open state with the trigger's press state. Additionally, it allows you to customize the type and
 * positioning of the Dialog.
 */ // We don't want getCollectionNode to show up in the type definition
let $c412c5ea680c1e4f$export$2e1e1122cf0cba88 = $c412c5ea680c1e4f$var$DialogTrigger;
function $c412c5ea680c1e4f$var$PopoverTrigger({ state: state, targetRef: targetRef, trigger: trigger, content: content, hideArrow: hideArrow, ...props }) {
    let triggerRef = (0, $b4euU$useRef)(null);
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $b4euU$useOverlayTrigger)({
        type: "dialog"
    }, state, triggerRef);
    let triggerPropsWithRef = {
        ...triggerProps,
        ref: targetRef ? undefined : triggerRef
    };
    let overlay = /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$Popover), {
        ...props,
        hideArrow: hideArrow,
        triggerRef: targetRef || triggerRef,
        state: state
    }, typeof content === "function" ? content(state.close) : content);
    return /*#__PURE__*/ (0, $b4euU$react).createElement($c412c5ea680c1e4f$var$DialogTriggerBase, {
        type: "popover",
        state: state,
        triggerProps: triggerPropsWithRef,
        dialogProps: overlayProps,
        trigger: trigger,
        overlay: overlay
    });
}
function $c412c5ea680c1e4f$var$DialogTriggerBase({ type: type, state: state, isDismissable: isDismissable, dialogProps: dialogProps = {}, triggerProps: triggerProps = {}, overlay: overlay, trigger: trigger }) {
    let context = {
        type: type,
        onClose: state.close,
        isDismissable: isDismissable,
        ...dialogProps
    };
    return /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$Fragment), null, /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$PressResponder), {
        ...triggerProps,
        onPress: state.toggle,
        isPressed: state.isOpen && type !== "modal" && type !== "fullscreen" && type !== "fullscreenTakeover"
    }, trigger), /*#__PURE__*/ (0, $b4euU$react).createElement((0, $97b119e05830ea0d$export$8b93a07348a7730c).Provider, {
        value: context
    }, overlay));
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



function $2a9f0ad39ddaa8d9$export$547754aada6e339f(props) {
    let { children: children, type: type = "modal", onDismiss: onDismiss, isDismissable: isDismissable, isKeyboardDismissDisabled: isKeyboardDismissDisabled } = props;
    let childArray = (0, $b4euU$react).Children.toArray(children);
    if (childArray.length > 1) throw new Error("Only a single child can be passed to DialogContainer.");
    let [lastChild, setLastChild] = (0, $b4euU$useState)(null);
    // React.Children.toArray mutates the children, and we need them to be stable
    // between renders so that the lastChild comparison works.
    let child = undefined;
    if (Array.isArray(children)) child = children.find((0, $b4euU$react).isValidElement);
    else if (/*#__PURE__*/ (0, $b4euU$react).isValidElement(children)) child = children;
    if (child && child !== lastChild) setLastChild(child);
    let context = {
        type: type,
        onClose: onDismiss,
        isDismissable: isDismissable
    };
    let state = (0, $b4euU$useOverlayTriggerState)({
        isOpen: !!child,
        onOpenChange: (isOpen)=>{
            if (!isOpen) onDismiss();
        }
    });
    return /*#__PURE__*/ (0, $b4euU$react).createElement((0, $b4euU$Modal), {
        state: state,
        type: type,
        isDismissable: isDismissable,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled
    }, /*#__PURE__*/ (0, $b4euU$react).createElement((0, $97b119e05830ea0d$export$8b93a07348a7730c).Provider, {
        value: context
    }, lastChild));
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

function $faffee7da30e8f89$export$a2f2d8fa6720dab1() {
    let context = (0, $b4euU$useContext)((0, $97b119e05830ea0d$export$8b93a07348a7730c));
    if (!context) throw new Error("Cannot call useDialogContext outside a <DialogTrigger> or <DialogContainer>.");
    return {
        type: context.type,
        dismiss () {
            context === null || context === void 0 ? void 0 : context.onClose();
        }
    };
}




export {$2a8395160fff9af3$export$de466dd8317b0b75 as AlertDialog, $99cd51dc4eb569f7$export$3ddf2d174ce01153 as Dialog, $c412c5ea680c1e4f$export$2e1e1122cf0cba88 as DialogTrigger, $2a9f0ad39ddaa8d9$export$547754aada6e339f as DialogContainer, $faffee7da30e8f89$export$a2f2d8fa6720dab1 as useDialogContainer};
//# sourceMappingURL=module.js.map
